import {useQuery} from "react-query";
import {fromNow, formatDate} from "../../../_helpers/DateTimeHelpers";
import {fetchUser} from "../../../../api/user";
import Loading from "./Loading";
import {LightTooltip} from "../../../_partials/tooltips";
import Skeleton from '@material-ui/lab/Skeleton';

export default function UserInfo({userId}) {
    const {isLoading, error, data, isFetching} = useQuery([
        'user',
        {userId}
    ], async () => {
        const {response, error} = await fetchUser(userId);

        return response ? response.data.data : response;
    }, {refetchOnWindowFocus: false});

    const getAvatar = (avatar) => {
        return avatar ? avatar : '/media/images/user_blank.png';
    }

    // if (!isLoading) {
    //     return <Skeleton animation="wave"  width={40} height={40} />;
    // }

    if (!isLoading && !data) {
        return <>Not found</>;
    }

    return (
        <div className={`offcanvas-content px-10 pt-6 scroll ps`}>
            <div className="d-flex align-items-center">
                <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                    <div className="symbol-label overflow-hidden">
                        {isLoading ? <Skeleton animation="wave" width={150} height={250}/> :
                            <img height={100} src={getAvatar(data.avatar)} alt=""/>}
                    </div>
                </div>
                <div>
                    <span className="font-weight-bold font-size-h5 text-dark-75s">
                        {isLoading ?
                            <Skeleton width={200} height={40}/> : data.user.firstname + ' ' + data.user.lastname}
                    </span>
                    <div className="text-muted">
                        {isLoading ? <Skeleton width={200} height={30}/> : data.user.job_position}
                    </div>
                </div>
            </div>
            <div className="pt-8 pb-6">
                {isLoading ? (
                    <>
                        <Skeleton width="100%" height={30}/>
                        <Skeleton width="100%" height={30}/>
                        <Skeleton width="100%" height={30}/>
                        <Skeleton width="100%" height={30}/>
                    </>
                ) : (
                    <>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="font-weight-bold mr-2">Email:</span>
                            <a href={`mailto:${data.user.email}`}
                               className="text-muted text-hover-primary">{data.user.email}</a>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="font-weight-bold mr-2">Phone:</span>
                            <span className="text-muted">{data.user.phone}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <span className="font-weight-bold mr-2">Phone 2:</span>
                            <span className="text-muted">{data.user.work_phone}</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="font-weight-bold mr-2">Registered:</span>
                            <LightTooltip title={formatDate(data.user.created_at)} arrow>
                                <span className="badge badge-primary">
                                        {fromNow(data.user.created_at)}
                                </span>
                            </LightTooltip>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
